import { parseRequestError } from '@/app/common/utilities'
import { useToast } from '@/shad/ui/toast/use-toast'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { paymentApprovalApi } from '../api'
import { paymentApprovalKeys } from '../keys'
import { ApprovalRulePayload } from '../schema'

export function useCreateRule() {
  const queryClient = useQueryClient()
  const { toast } = useToast()

  return useMutation({
    mutationFn: async (rule: ApprovalRulePayload) => {
      return await paymentApprovalApi.createRule(rule)
    },
    onSuccess: () => {
      toast({
        title: 'Rule Created',
        description: 'The rule has been created successfully.',
      })
    },
    onError: (error) => {
      const newError = parseRequestError(error)
      toast({
        title: 'Error',
        description: newError.message,
        variant: 'destructive',
      })
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        // Invalidate all queries starting with the base key so we don't have to pass the query params to the invalidateQueries function
        queryKey: [paymentApprovalKeys.allRules()[0]],
      })
    },
  })
}
